<div class="orderGroup-container ya-typography">
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="group-content group-invite-content">
      <div class="icon-container sign title-margin">
        <div class="inline-icon" inlineSVG="hypersoft-gruppencheck.svg"></div>
      </div>
      <div class="group-info-item">
        <p class="text info-label content-container--subfont text-highlight" [innerHtml]="groupCreatedInfo">
        </p>
      </div>
      <div class=" group-info-item">
        <p class="text content-container--subfont textborder" langkey="phRemoteOrder_GroupCreate_Confirm_Nav_Info">
        </p>
        <p class="text content-container--subfont textborder" langkey="phRemoteOrder_GroupCreate_Confirm_Pay_Info">
        </p>
      </div>
    </div>
    <div class="group-invite-content">
      <div class="icon-container sign">
        <div class="inline-icon" inlineSVG="hypersoft-user-plus.svg"></div>
      </div>
      <div class="group-info-item">
        <p class="text content-container--subfont" langkey="phRemoteOrder_GroupCreate_Confirm_Invite_Info"></p>
      </div>
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <div class="ya-webshop-button-container">
            <button mat-flat-button (click)="NavigateToShare()">
              <span langkey="phRemoteOrder_GroupCreate_Confirm__Invite_Btn"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="webshop-button-wrapper">
      <div class="ya-webshop-button-container webshop-ghost-button">
        <button mat-flat-button (click)="NavigateToMenu()"><span
            langkey="phRemoteOrder_Without_Invite_Btn"></span></button>
      </div>
    </div>
  </div>
</div>